import {TicketActionDto} from "../../../../../../model/dto/entity/ticket-action.dto";
import {TicketActionStatusInternal} from "../../../../../../enum/ticket-action-status-internal.enum";
import {ObjectIdentifier} from "../../../../../../../../core/shared/basic/object-identifier";

export class UiTicketActionDto {
    ticketAction: TicketActionDto;
    showComments: boolean;
    icon: string;
    buttonClass: string;
    tooltip: string;
    status: string;
    statusEnum:  TicketActionStatusInternal;
    statusColor: string;
    statusBackgroundColor: string;
    commentsIdentifier: ObjectIdentifier;
    isProcess: boolean;
    actionIcon: string;
    isTicket: boolean;
    isNotification: boolean;
    isAppointment: boolean;
    isStarted: boolean;
    showSimple: boolean;
}